module.exports = __webpack_public_path__ + "img/steps1.bbdeb32e.svg";